<ngx-spinner type="ball-clip-rotate"></ngx-spinner>

<div id="background"></div>
<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-sgzp-app4-login></app-sgzp-app4-login>
  </div>

  <div *ngIf="page === 'register'">
    <app-sgzp-app4-register></app-sgzp-app4-register>
  </div>

  <div *ngIf="page === 'forgot-password'">
    <app-sgzp-app4-forgot-password></app-sgzp-app4-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-sgzp-app4-change-password-sent></app-sgzp-app4-change-password-sent>
  </div>

  <app-sgzp-app4-register-resend
    *ngIf="page === 'register-resend'"
  ></app-sgzp-app4-register-resend>
</ng-container>
